<div
  [class.healthy]="this.status===1"
  [class.unhealthy]="this.status===2"
  [class.atRisk]="this.status===3"
  [class.notActive]="this.status===99"
>
  {{healthStatus}}
</div>
